exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app {\n  max-width: 800px;\n  margin: 0 auto;\n}\n", ""]);

// exports
